module.exports = __webpack_public_path__ + "static/media/arrow-left-full.9a81314f.svg";